import { useState, useEffect } from "react";
import { Link } from "react-router";
import ScriptText from "./ScriptText";
import { CONSENT_KEY } from "@/lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay so banner doesn't compete with page load animation
    const timer = setTimeout(() => {
      if (!localStorage.getItem(CONSENT_KEY)) {
        setVisible(true);
      }
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    window.dispatchEvent(new Event("consent-changed"));
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
    window.dispatchEvent(new Event("consent-changed"));
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="mx-auto max-w-2xl rounded-sm border border-warm-stone/20 bg-antique-linen/95 px-6 py-6 shadow-lg backdrop-blur-sm sm:px-8 sm:py-7">
        {/* Script accent */}
        <ScriptText className="mb-2 block text-2xl">A small note</ScriptText>

        {/* Body */}
        <p className="font-body text-sm leading-relaxed text-soft-charcoal/80">
          We use cookies and similar technologies to understand how you explore
          our site, so we can make the experience even more beautiful.{" "}
          <Link
            to="/privacy-policy"
            className="underline decoration-warm-stone/40 underline-offset-2 transition-colors hover:text-faded-terracotta"
          >
            Read our privacy policy
          </Link>
        </p>

        {/* Actions */}
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <button
            onClick={accept}
            className="inline-block cursor-pointer rounded-sm bg-faded-terracotta px-7 py-2.5 font-body text-xs tracking-[0.15em] uppercase text-parchment transition-all duration-500 hover:bg-fig"
          >
            Accept
          </button>
          <button
            onClick={decline}
            className="inline-block cursor-pointer rounded-sm border border-warm-stone/30 px-7 py-2.5 font-body text-xs tracking-[0.15em] uppercase text-soft-charcoal/70 transition-all duration-500 hover:border-soft-charcoal/40 hover:text-soft-charcoal"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
